module.exports = __webpack_public_path__ + "static/media/avast-vince-scientist.a9ba486a.jpg";